import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  loaderImg: {
    height: '100px',
    width: '100px',
  },
}));
